import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getOrgs = async () => {
  const res = await Api.get<AdminTypes.OrganizationDto[]>('/admin/v1/orgs');
  return res.data;
};
